import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

@Injectable()
export class AdminResolver implements Resolve<boolean> {
  constructor(private auth: AuthService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.auth.isAdminUser()) {
      this.router.navigate(['login']);
    }

    return this.auth.isAdminUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/admin.guard.ts